if (!customElements.get('customer-verification-form-section')) {
  customElements.define(
    'customer-verification-form-section',
    class CustomerVerificationFormSection extends HTMLElement {
      connectedCallback() {
        /** @type {NodeListOf<HTMLElement>} */
        this.stepItems = this.querySelectorAll('[data-step-item]');
        /** @type {NodeListOf<HTMLElement>} */
        this.stepPanels = this.querySelectorAll('[data-step-panel]');
        /** @type {NodeListOf<HTMLButtonElement>} */
        this.previousButtons = this.querySelectorAll('[data-step-previous]');
        /** @type {NodeListOf<HTMLButtonElement>} */
        this.nextButtons = this.querySelectorAll('[data-step-next]');
        this.submitButton = this.querySelector('[data-step-submit]');
        this.arrivalRoot = this.querySelector('[data-arrival-root]');
        this.arrivalContinueButton = this.querySelector('[data-arrival-continue]');
        /** @type {NodeListOf<HTMLInputElement>} */
        this.arrivalChoices = this.querySelectorAll('[data-arrival-choice]');
        this.arrivalSubstepOne = this.querySelector('[data-arrival-substep="1"]');
        this.arrivalSubstepYes = this.querySelector('[data-arrival-substep="2-yes"]');
        this.arrivalSubstepNo = this.querySelector('[data-arrival-substep="2-no"]');
        this.arrivalDate = this.querySelector('[data-arrival-date]');
        this.arrivalMonth = this.querySelector('[data-arrival-month]');
        this.arrivalYear = this.querySelector('[data-arrival-year]');
        this.arrivalCalendar = this.querySelector('[data-arrival-calendar]');
        this.arrivalCalendarMonthSelect = this.querySelector('[data-arrival-calendar-month-select]');
        this.arrivalCalendarYearSelect = this.querySelector('[data-arrival-calendar-year-select]');
        this.arrivalCalendarGrid = this.querySelector('[data-arrival-calendar-grid]');
        this.arrivalCalendarPrev = this.querySelector('[data-arrival-calendar-prev]');
        this.arrivalCalendarNext = this.querySelector('[data-arrival-calendar-next]');
        this.deliveryContinueButton = this.querySelector('[data-delivery-continue]');
        this.deliveryProvinceSelect = this.querySelector('[data-delivery-province]');
        this.deliverySubstepOne = this.querySelector('[data-delivery-substep="1"]');
        this.deliverySubstepTwo = this.querySelector('[data-delivery-substep="2"]');
        this.deliverySubstepThree = this.querySelector('[data-delivery-substep="3"]');
        this.deliveryOptionsWithAirport = this.querySelector('[data-delivery-options-set="with-airport"]');
        this.deliveryOptionsWithoutAirport = this.querySelector('[data-delivery-options-set="without-airport"]');
        /** @type {NodeListOf<HTMLInputElement>} */
        this.deliveryOptionInputs = this.querySelectorAll('[data-delivery-option]');
        this.deliveryEsimContent = this.querySelector('[data-delivery-option-content="esim"]');
        this.deliveryEsimHelpToggle = this.querySelector('[data-delivery-esim-help-toggle]');
        this.deliveryEsimHelp = this.querySelector('[data-delivery-esim-help]');
        this.deliveryEsimEmail = this.querySelector('[data-delivery-esim-email]');
        this.deliveryAirportContent = this.querySelector('[data-delivery-option-content="airport"]');
        this.deliveryAirportSelect = this.querySelector('[data-delivery-airport-select]');
        this.deliveryHomeCountryContent = this.querySelector('[data-delivery-option-content="home-country"]');
        this.deliveryHomeCountry = this.querySelector('[data-delivery-home-country]');
        /** @type {NodeListOf<HTMLInputElement>} */
        this.deliveryHomeCountryFields = this.querySelectorAll('[data-delivery-home-country-field]');
        this.deliveryCanadianAddressContent = this.querySelector(
          '[data-delivery-option-content="canadian-address"]'
        );
        this.deliveryCanadianProvince = this.querySelector('[data-delivery-canadian-province]');
        /** @type {NodeListOf<HTMLInputElement>} */
        this.deliveryCanadianFields = this.querySelectorAll('[data-delivery-canadian-field]');
        this.primaryEmailInput = this.querySelector('[name="contact[email]"]');
        this.firstNameInput = this.querySelector('[name="contact[first_name]"]');
        this.lastNameInput = this.querySelector('[name="contact[last_name]"]');
        this.phoneInput = this.querySelector('[name="contact[phone]"]');
        this.dateOfBirthInput = this.querySelector('[name="contact[date_of_birth]"]');
        this.arrivalMonthInput = this.querySelector('[name="contact[arrival_month]"]');
        this.arrivalYearInput = this.querySelector('[name="contact[arrival_year]"]');
        this.deliveryOptionInput = this.querySelector('[name="contact[delivery_option]"]:checked');
        this.deliveryCountryInput = this.querySelector('[name="contact[delivery_country]"]');
        this.homeCountryAddressInput = this.querySelector('[name="contact[home_country_address]"]');
        this.homeCountryUnitInput = this.querySelector('[name="contact[home_country_unit]"]');
        this.homeCountryCityInput = this.querySelector('[name="contact[home_country_city]"]');
        this.homeCountryRegionInput = this.querySelector('[name="contact[home_country_region]"]');
        this.homeCountryCountryInput = this.querySelector('[name="contact[home_country_country]"]');
        this.homeCountryZipInput = this.querySelector('[name="contact[home_country_zip]"]');
        this.canadianAddressInput = this.querySelector('[name="contact[canadian_address_line]"]');
        this.canadianUnitInput = this.querySelector('[name="contact[canadian_address_unit]"]');
        this.canadianPostalInput = this.querySelector('[name="contact[canadian_address_postal_code]"]');
        this.canadianCityInput = this.querySelector('[name="contact[canadian_address_city]"]');
        this.canadianProvinceInput = this.querySelector('[name="contact[canadian_address_province]"]');

        this.reviewFullName = this.querySelector('[data-review-full-name]');
        this.reviewPhone = this.querySelector('[data-review-phone]');
        this.reviewDateOfBirth = this.querySelector('[data-review-date-of-birth]');
        this.reviewEmail = this.querySelector('[data-review-email]');
        this.reviewArrivalDate = this.querySelector('[data-review-arrival-date]');
        this.reviewDeliveryType = this.querySelector('[data-review-delivery-type]');
        this.reviewDeliveryDetails = this.querySelector('[data-review-delivery-details]');

        if (!this.stepPanels.length || !this.stepItems.length) {
          return;
        }

        /** @type {number} */
        this.totalSteps = this.stepPanels.length;
        /** @type {number} */
        this.currentStep = 1;
        /** @type {number} */
        this.maxReachedStep = 1;
        this.arrivalSubstep = 1;
        this.arrivalChoiceValue = '';
        this.deliverySubstep = 1;
        this.deliveryOptionSet = '';
        /** @type {string} */
        this.deliverySelectedOptionValue = '';

        this.onPreviousClick = this.onPreviousClick.bind(this);
        this.onNextClick = this.onNextClick.bind(this);
        this.onStepItemClick = this.onStepItemClick.bind(this);
        this.onStepItemKeydown = this.onStepItemKeydown.bind(this);
        this.onArrivalContinueClick = this.onArrivalContinueClick.bind(this);
        this.onArrivalChoiceChange = this.onArrivalChoiceChange.bind(this);
        this.onArrivalDateChange = this.onArrivalDateChange.bind(this);
        this.onCalendarMonthChange = this.onCalendarMonthChange.bind(this);
        this.onCalendarYearChange = this.onCalendarYearChange.bind(this);
        this.onCalendarPrevClick = this.onCalendarPrevClick.bind(this);
        this.onCalendarNextClick = this.onCalendarNextClick.bind(this);
        this.onCalendarGridClick = this.onCalendarGridClick.bind(this);
        this.onDeliveryContinueClick = this.onDeliveryContinueClick.bind(this);
        this.onDeliveryProvinceChange = this.onDeliveryProvinceChange.bind(this);
        this.onDeliveryOptionChange = this.onDeliveryOptionChange.bind(this);
        this.onDeliveryEsimHelpToggleClick = this.onDeliveryEsimHelpToggleClick.bind(this);

        this.previousButtons.forEach((button) => {
          button.addEventListener('click', this.onPreviousClick);
        });
        this.nextButtons.forEach((button) => {
          button.addEventListener('click', this.onNextClick);
        });
        this.stepItems.forEach((stepItem) => {
          stepItem.addEventListener('click', this.onStepItemClick);
          stepItem.addEventListener('keydown', this.onStepItemKeydown);
        });
        if (this.arrivalContinueButton instanceof HTMLButtonElement) {
          this.arrivalContinueButton.addEventListener('click', this.onArrivalContinueClick);
        }
        this.arrivalChoices.forEach((choice) => {
          choice.addEventListener('change', this.onArrivalChoiceChange);
        });
        if (this.arrivalDate instanceof HTMLInputElement) {
          this.arrivalDate.addEventListener('input', this.onArrivalDateChange);
          this.arrivalDate.addEventListener('change', this.onArrivalDateChange);
        }
        if (this.arrivalCalendarMonthSelect instanceof HTMLSelectElement) {
          this.arrivalCalendarMonthSelect.addEventListener('change', this.onCalendarMonthChange);
        }
        if (this.arrivalCalendarYearSelect instanceof HTMLSelectElement) {
          this.arrivalCalendarYearSelect.addEventListener('change', this.onCalendarYearChange);
        }
        if (this.arrivalCalendarPrev instanceof HTMLButtonElement) {
          this.arrivalCalendarPrev.addEventListener('click', this.onCalendarPrevClick);
        }
        if (this.arrivalCalendarNext instanceof HTMLButtonElement) {
          this.arrivalCalendarNext.addEventListener('click', this.onCalendarNextClick);
        }
        if (this.arrivalCalendarGrid instanceof HTMLElement) {
          this.arrivalCalendarGrid.addEventListener('click', this.onCalendarGridClick);
        }
        if (this.deliveryContinueButton instanceof HTMLButtonElement) {
          this.deliveryContinueButton.addEventListener('click', this.onDeliveryContinueClick);
        }
        if (this.deliveryProvinceSelect instanceof HTMLSelectElement) {
          this.deliveryProvinceSelect.addEventListener('change', this.onDeliveryProvinceChange);
        }
        this.deliveryOptionInputs.forEach((input) => {
          input.addEventListener('change', this.onDeliveryOptionChange);
        });
        if (this.deliveryEsimHelpToggle instanceof HTMLButtonElement) {
          this.deliveryEsimHelpToggle.addEventListener('click', this.onDeliveryEsimHelpToggleClick);
        }

        this.initArrivalCalendar();

        this.updateView();
      }

      disconnectedCallback() {
        /** @type {NodeListOf<HTMLButtonElement>} */
        const previousButtons = this.previousButtons || this.querySelectorAll('[data-step-previous]');
        previousButtons.forEach((button) => {
          button.removeEventListener('click', this.onPreviousClick);
        });
        /** @type {NodeListOf<HTMLButtonElement>} */
        const nextButtons = this.nextButtons || this.querySelectorAll('[data-step-next]');
        nextButtons.forEach((button) => {
          button.removeEventListener('click', this.onNextClick);
        });
        const stepItems = this.stepItems || this.querySelectorAll('[data-step-item]');
        stepItems.forEach((stepItem) => {
          stepItem.removeEventListener('click', this.onStepItemClick);
          stepItem.removeEventListener('keydown', this.onStepItemKeydown);
        });
        if (this.arrivalContinueButton instanceof HTMLButtonElement) {
          this.arrivalContinueButton.removeEventListener('click', this.onArrivalContinueClick);
        }
        /** @type {NodeListOf<HTMLInputElement>} */
        const arrivalChoices = this.arrivalChoices || this.querySelectorAll('[data-arrival-choice]');
        arrivalChoices.forEach((choice) => {
          choice.removeEventListener('change', this.onArrivalChoiceChange);
        });
        if (this.arrivalDate instanceof HTMLInputElement) {
          this.arrivalDate.removeEventListener('input', this.onArrivalDateChange);
          this.arrivalDate.removeEventListener('change', this.onArrivalDateChange);
        }
        if (this.arrivalCalendarMonthSelect instanceof HTMLSelectElement) {
          this.arrivalCalendarMonthSelect.removeEventListener('change', this.onCalendarMonthChange);
        }
        if (this.arrivalCalendarYearSelect instanceof HTMLSelectElement) {
          this.arrivalCalendarYearSelect.removeEventListener('change', this.onCalendarYearChange);
        }
        if (this.arrivalCalendarPrev instanceof HTMLButtonElement) {
          this.arrivalCalendarPrev.removeEventListener('click', this.onCalendarPrevClick);
        }
        if (this.arrivalCalendarNext instanceof HTMLButtonElement) {
          this.arrivalCalendarNext.removeEventListener('click', this.onCalendarNextClick);
        }
        if (this.arrivalCalendarGrid instanceof HTMLElement) {
          this.arrivalCalendarGrid.removeEventListener('click', this.onCalendarGridClick);
        }
        if (this.deliveryContinueButton instanceof HTMLButtonElement) {
          this.deliveryContinueButton.removeEventListener('click', this.onDeliveryContinueClick);
        }
        if (this.deliveryProvinceSelect instanceof HTMLSelectElement) {
          this.deliveryProvinceSelect.removeEventListener('change', this.onDeliveryProvinceChange);
        }
        /** @type {NodeListOf<HTMLInputElement>} */
        const deliveryOptionInputs = this.deliveryOptionInputs || this.querySelectorAll('[data-delivery-option]');
        deliveryOptionInputs.forEach((input) => {
          input.removeEventListener('change', this.onDeliveryOptionChange);
        });
        if (this.deliveryEsimHelpToggle instanceof HTMLButtonElement) {
          this.deliveryEsimHelpToggle.removeEventListener('click', this.onDeliveryEsimHelpToggleClick);
        }
      }

      initArrivalCalendar() {
        const initialDate = this.parseDateInputValue(
          this.arrivalDate instanceof HTMLInputElement ? this.arrivalDate.value : ''
        );

        const now = initialDate || new Date();
        this.calendarMinYear = new Date().getFullYear();
        this.calendarMaxYear = this.calendarMinYear + 3;
        this.calendarVisibleYear = now.getFullYear();
        this.calendarVisibleMonth = now.getMonth();
        this.selectedArrivalDate = initialDate;
        this.populateCalendarYearSelect();
        this.normalizeCalendarVisibleDate();
        this.renderArrivalCalendar();
      }
      populateCalendarYearSelect() {
        if (
          !(this.arrivalCalendarYearSelect instanceof HTMLSelectElement) ||
          typeof this.calendarMinYear !== 'number' ||
          typeof this.calendarMaxYear !== 'number'
        ) {
          return;
        }

        this.arrivalCalendarYearSelect.innerHTML = '';
        for (let year = this.calendarMinYear; year <= this.calendarMaxYear; year += 1) {
          const option = document.createElement('option');
          option.value = String(year);
          option.textContent = String(year);
          this.arrivalCalendarYearSelect.appendChild(option);
        }
      }

      normalizeCalendarVisibleDate() {
        if (
          typeof this.calendarVisibleYear !== 'number' ||
          typeof this.calendarMinYear !== 'number' ||
          typeof this.calendarMaxYear !== 'number'
        ) {
          return;
        }

        if (this.calendarVisibleYear < this.calendarMinYear) {
          this.calendarVisibleYear = this.calendarMinYear;
        }
        if (this.calendarVisibleYear > this.calendarMaxYear) {
          this.calendarVisibleYear = this.calendarMaxYear;
        }
      }


      /**
       * @param {string} value
       * @returns {Date | null}
       */
      parseDateInputValue(value) {
        if (!value) return null;
        const match = value.match(/^(\d{4})-(\d{2})-(\d{2})$/);
        if (!match) return null;

        const year = Number(match[1]);
        const monthIndex = Number(match[2]) - 1;
        const day = Number(match[3]);

        if (Number.isNaN(year) || Number.isNaN(monthIndex) || Number.isNaN(day)) return null;

        const date = new Date(year, monthIndex, day);
        if (
          date.getFullYear() !== year ||
          date.getMonth() !== monthIndex ||
          date.getDate() !== day
        ) {
          return null;
        }

        return date;
      }

      /**
       * @param {Date} date
       * @returns {string}
       */
      formatDateForInput(date) {
        const year = String(date.getFullYear());
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
      }

      onArrivalDateChange() {
        if (!(this.arrivalDate instanceof HTMLInputElement)) return;

        const parsedDate = this.parseDateInputValue(this.arrivalDate.value);
        this.selectedArrivalDate = parsedDate;

        if (parsedDate) {
          this.calendarVisibleYear = parsedDate.getFullYear();
          this.calendarVisibleMonth = parsedDate.getMonth();
          this.normalizeCalendarVisibleDate();
        }

        this.renderArrivalCalendar();
      }

      /**
       * @param {Event} event
       */
      onCalendarMonthChange(event) {
        if (!(event.target instanceof HTMLSelectElement)) {
          return;
        }
        const month = Number(event.target.value);
        if (Number.isNaN(month) || month < 0 || month > 11) {
          return;
        }
        this.calendarVisibleMonth = month;
        this.renderArrivalCalendar();
      }

      /**
       * @param {Event} event
       */
      onCalendarYearChange(event) {
        if (!(event.target instanceof HTMLSelectElement)) {
          return;
        }
        const year = Number(event.target.value);
        if (Number.isNaN(year)) {
          return;
        }
        this.calendarVisibleYear = year;
        this.renderArrivalCalendar();
      }

      onCalendarPrevClick() {
        if (
          typeof this.calendarVisibleMonth !== 'number' ||
          typeof this.calendarVisibleYear !== 'number' ||
          typeof this.calendarMinYear !== 'number'
        ) {
          return;
        }

        if (this.calendarVisibleYear === this.calendarMinYear && this.calendarVisibleMonth === 0) {
          return;
        }

        this.calendarVisibleMonth -= 1;
        if (this.calendarVisibleMonth < 0) {
          this.calendarVisibleMonth = 11;
          this.calendarVisibleYear -= 1;
        }
        this.normalizeCalendarVisibleDate();
        this.renderArrivalCalendar();
      }

      onCalendarNextClick() {
        if (
          typeof this.calendarVisibleMonth !== 'number' ||
          typeof this.calendarVisibleYear !== 'number' ||
          typeof this.calendarMaxYear !== 'number'
        ) {
          return;
        }

        if (this.calendarVisibleYear === this.calendarMaxYear && this.calendarVisibleMonth === 11) {
          return;
        }

        this.calendarVisibleMonth += 1;
        if (this.calendarVisibleMonth > 11) {
          this.calendarVisibleMonth = 0;
          this.calendarVisibleYear += 1;
        }
        this.normalizeCalendarVisibleDate();
        this.renderArrivalCalendar();
      }

      /**
       * @param {Event} event
       */
      onCalendarGridClick(event) {
        const target = event.target;
        if (!(target instanceof HTMLElement)) return;

        const dayButton = target.closest('[data-arrival-day]');
        if (!(dayButton instanceof HTMLButtonElement)) return;
        if (typeof this.calendarVisibleYear !== 'number' || typeof this.calendarVisibleMonth !== 'number') return;

        const day = Number(dayButton.dataset.arrivalDay);
        if (Number.isNaN(day) || day < 1) return;

        const selectedDate = new Date(this.calendarVisibleYear, this.calendarVisibleMonth, day);
        this.selectedArrivalDate = selectedDate;

        if (this.arrivalDate instanceof HTMLInputElement) {
          this.arrivalDate.value = this.formatDateForInput(selectedDate);
        }

        this.renderArrivalCalendar();
      }

      renderArrivalCalendar() {
        if (
          !(this.arrivalCalendarMonthSelect instanceof HTMLSelectElement) ||
          !(this.arrivalCalendarYearSelect instanceof HTMLSelectElement) ||
          !(this.arrivalCalendarGrid instanceof HTMLElement) ||
          typeof this.calendarVisibleMonth !== 'number' ||
          typeof this.calendarVisibleYear !== 'number'
        ) {
          return;
        }

        this.arrivalCalendarMonthSelect.value = String(this.calendarVisibleMonth);
        this.arrivalCalendarYearSelect.value = String(this.calendarVisibleYear);

        if (this.arrivalCalendarPrev instanceof HTMLButtonElement && typeof this.calendarMinYear === 'number') {
          this.arrivalCalendarPrev.disabled =
            this.calendarVisibleYear === this.calendarMinYear && this.calendarVisibleMonth === 0;
        }
        if (this.arrivalCalendarNext instanceof HTMLButtonElement && typeof this.calendarMaxYear === 'number') {
          this.arrivalCalendarNext.disabled =
            this.calendarVisibleYear === this.calendarMaxYear && this.calendarVisibleMonth === 11;
        }

        this.arrivalCalendarGrid.innerHTML = '';

        const firstDayWeekIndex = new Date(this.calendarVisibleYear, this.calendarVisibleMonth, 1).getDay();
        const daysInMonth = new Date(this.calendarVisibleYear, this.calendarVisibleMonth + 1, 0).getDate();

        for (let i = 0; i < firstDayWeekIndex; i += 1) {
          const emptyCell = document.createElement('span');
          emptyCell.className = 'customer-verification-form__arrival-calendar-empty';
          this.arrivalCalendarGrid.appendChild(emptyCell);
        }

        for (let day = 1; day <= daysInMonth; day += 1) {
          const dayButton = document.createElement('button');
          dayButton.type = 'button';
          dayButton.className = 'customer-verification-form__arrival-calendar-day';
          dayButton.dataset.arrivalDay = String(day);
          dayButton.textContent = String(day);

          if (
            this.selectedArrivalDate instanceof Date &&
            this.selectedArrivalDate.getFullYear() === this.calendarVisibleYear &&
            this.selectedArrivalDate.getMonth() === this.calendarVisibleMonth &&
            this.selectedArrivalDate.getDate() === day
          ) {
            dayButton.classList.add('is-active');
          }

          this.arrivalCalendarGrid.appendChild(dayButton);
        }
      }

      onPreviousClick() {
        if (typeof this.currentStep !== 'number') {
          return;
        }

        if (this.currentStep === 3 && this.deliverySubstep === 3) {
          this.deliverySubstep = 2;
          this.updateDeliverySubstepView();
          this.updateView();
          return;
        }

        if (this.currentStep === 3 && this.deliverySubstep === 2) {
          this.deliverySubstep = 1;
          this.updateDeliverySubstepView();
          this.updateView();
          return;
        }

        if (this.currentStep === 2 && this.arrivalSubstep === 2) {
          this.arrivalSubstep = 1;
          this.updateArrivalSubstepView();
          this.updateView();
          return;
        }

        if (this.currentStep <= 1) {
          return;
        }

        this.currentStep -= 1;
        this.updateView();
      }

      /**
       * @param {MouseEvent} event
       */
      onStepItemClick(event) {
        if (!(event.currentTarget instanceof HTMLElement)) {
          return;
        }

        const stepNumber = Number(event.currentTarget.dataset.stepItem);
        this.goToStepByStepper(stepNumber);
      }

      /**
       * @param {KeyboardEvent} event
       */
      onStepItemKeydown(event) {
        if (!(event.currentTarget instanceof HTMLElement)) {
          return;
        }

        if (event.key !== 'Enter' && event.key !== ' ') {
          return;
        }

        event.preventDefault();
        const stepNumber = Number(event.currentTarget.dataset.stepItem);
        this.goToStepByStepper(stepNumber);
      }

      /**
       * @param {number} stepNumber
       */
      goToStepByStepper(stepNumber) {
        if (
          Number.isNaN(stepNumber) ||
          typeof this.currentStep !== 'number' ||
          typeof this.maxReachedStep !== 'number'
        ) {
          return;
        }

        if (stepNumber === this.currentStep) {
          return;
        }

        if (stepNumber < 1 || stepNumber > this.maxReachedStep) {
          return;
        }

        this.currentStep = stepNumber;
        this.updateView();
      }

      onArrivalChoiceChange() {
        const selectedChoice = this.querySelector('[data-arrival-choice]:checked');
        if (selectedChoice instanceof HTMLInputElement) {
          this.arrivalChoiceValue = selectedChoice.value;
        }
      }

      onArrivalContinueClick() {
        if (typeof this.currentStep !== 'number' || this.currentStep !== 2) {
          return;
        }

        const selectedChoice = this.querySelector('[data-arrival-choice]:checked');
        if (!(selectedChoice instanceof HTMLInputElement)) {
          /** @type {NodeListOf<HTMLInputElement>} */
          const arrivalChoices = this.arrivalChoices || this.querySelectorAll('[data-arrival-choice]');
          const firstChoice = arrivalChoices[0];
          if (firstChoice instanceof HTMLInputElement) {
            firstChoice.reportValidity();
          }
          return;
        }

        this.arrivalChoiceValue = selectedChoice.value;
        this.arrivalSubstep = 2;
        this.updateArrivalSubstepView();
      }

      onDeliveryProvinceChange() {
        if (!(this.deliveryProvinceSelect instanceof HTMLSelectElement)) {
          return;
        }
        this.deliveryOptionSet = this.getDeliveryOptionSetByProvince(this.deliveryProvinceSelect.value);
      }

      onDeliveryContinueClick() {
        if (typeof this.currentStep !== 'number' || this.currentStep !== 3) {
          return;
        }

        if (!this.validateCurrentStep()) {
          return;
        }

        const provinceCode =
          this.deliveryProvinceSelect instanceof HTMLSelectElement ? this.deliveryProvinceSelect.value : '';
        this.deliveryOptionSet = this.getDeliveryOptionSetByProvince(provinceCode);
        this.deliverySubstep = 2;
        this.updateDeliverySubstepView();
      }

      onDeliveryOptionChange() {
        let selectedValue = '';
        /** @type {NodeListOf<HTMLInputElement>} */
        const deliveryOptionInputs = this.deliveryOptionInputs || this.querySelectorAll('[data-delivery-option]');
        deliveryOptionInputs.forEach((input) => {
          if (input.checked) {
            selectedValue = input.value;
          }
        });
        this.deliverySelectedOptionValue = selectedValue;

        if (
          this.currentStep === 3 &&
          this.deliverySubstep === 2 &&
          (selectedValue === 'Get an eSIM' ||
            selectedValue === 'Pickup at the Airport' ||
            selectedValue === 'Deliver to my Home Country' ||
            selectedValue === 'Deliver to Canadian Address')
        ) {
          this.deliverySubstep = 3;
        }

        this.updateDeliverySubstepView();
      }

      onDeliveryEsimHelpToggleClick() {
        if (!(this.deliveryEsimHelp instanceof HTMLElement)) {
          return;
        }
        const isHidden = this.deliveryEsimHelp.hasAttribute('hidden');
        this.deliveryEsimHelp.toggleAttribute('hidden', !isHidden);
      }

      /**
       * @param {string} provinceCode
       * @returns {string}
       */
      getDeliveryOptionSetByProvince(provinceCode) {
        const provincesWithAirportPickup = new Set(['AB', 'MB', 'NL', 'NS', 'ON']);
        const provincesWithoutAirportPickup = new Set(['BC', 'NB', 'NT', 'NU', 'PE', 'QC', 'SK', 'YT']);

        if (provincesWithAirportPickup.has(provinceCode)) {
          return 'with-airport';
        }
        if (provincesWithoutAirportPickup.has(provinceCode)) {
          return 'without-airport';
        }
        return '';
      }

      onNextClick() {
        if (typeof this.currentStep !== 'number' || typeof this.totalSteps !== 'number') {
          return;
        }

        if (!this.validateCurrentStep()) {
          return;
        }

        if (this.currentStep >= this.totalSteps) {
          return;
        }

        this.currentStep += 1;
        const maxReachedStep = typeof this.maxReachedStep === 'number' ? this.maxReachedStep : 1;
        this.maxReachedStep = Math.max(maxReachedStep, this.currentStep);
        this.updateView();
      }

      validateCurrentStep() {
        const currentPanel = this.querySelector(`[data-step-panel="${this.currentStep}"]`);
        if (!currentPanel) {
          return true;
        }

        const fields = currentPanel.querySelectorAll('input, select, textarea');
        for (const field of fields) {
          if (
            !(
              field instanceof HTMLInputElement ||
              field instanceof HTMLSelectElement ||
              field instanceof HTMLTextAreaElement
            )
          ) {
            continue;
          }
          if (field.closest('[hidden]')) continue;
          if (!field.checkValidity()) {
            field.reportValidity();
            return false;
          }
        }

        return true;
      }

      updateView() {
        const currentStep = typeof this.currentStep === 'number' ? this.currentStep : 1;
        const totalSteps = typeof this.totalSteps === 'number' ? this.totalSteps : 1;
        const maxReachedStep = typeof this.maxReachedStep === 'number' ? this.maxReachedStep : 1;
        /** @type {NodeListOf<HTMLElement>} */
        const stepItems = this.stepItems || this.querySelectorAll('[data-step-item]');
        stepItems.forEach((stepItem, index) => {
          const stepNumber = index + 1;
          stepItem.classList.toggle('is-active', stepNumber === currentStep);
          stepItem.classList.toggle('is-complete', stepNumber < currentStep);
          const isClickable = stepNumber <= maxReachedStep && stepNumber !== currentStep;
          stepItem.classList.toggle('is-clickable', isClickable);
          stepItem.tabIndex = isClickable ? 0 : -1;
          stepItem.setAttribute('aria-disabled', String(!isClickable));

          if (stepNumber === currentStep) {
            stepItem.setAttribute('aria-current', 'step');
          } else {
            stepItem.removeAttribute('aria-current');
          }
        });

        /** @type {NodeListOf<HTMLElement>} */
        const stepPanels = this.stepPanels || this.querySelectorAll('[data-step-panel]');
        stepPanels.forEach((panel, index) => {
          const stepNumber = index + 1;
          const isCurrent = stepNumber === currentStep;
          panel.classList.toggle('is-active', isCurrent);
          panel.toggleAttribute('hidden', !isCurrent);
        });

        /** @type {NodeListOf<HTMLButtonElement>} */
        const previousButtons = this.previousButtons || this.querySelectorAll('[data-step-previous]');
        previousButtons.forEach((button) => {
          const isHidden = currentStep === 1;
          button.disabled = isHidden;
          button.toggleAttribute('hidden', isHidden);
        });

        /** @type {NodeListOf<HTMLButtonElement>} */
        const nextButtons = this.nextButtons || this.querySelectorAll('[data-step-next]');
        nextButtons.forEach((button) => {
          button.toggleAttribute('hidden', currentStep === totalSteps);
        });

        if (this.submitButton instanceof HTMLButtonElement) {
          this.submitButton.toggleAttribute('hidden', currentStep !== totalSteps);
        }

        if (currentStep !== 2) {
          this.arrivalSubstep = 1;
        }
        if (currentStep !== 3) {
          this.deliverySubstep = 1;
        }
        this.updateArrivalSubstepView();
        this.updateDeliverySubstepView();
        this.updateReviewData();
      }

      /**
       * @param {string} value
       * @returns {string}
       */
      getSafeValue(value) {
        return value && value.trim() !== '' ? value.trim() : '-';
      }

      /**
       * @param {string} value
       * @returns {string}
       */
      formatReadableDate(value) {
        if (!value) return '-';
        const parsed = new Date(value);
        if (Number.isNaN(parsed.getTime())) return value;
        return parsed.toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' });
      }

      /**
       * @param {Array<{label: string, value: string}>} items
       */
      renderReviewDeliveryDetails(items) {
        if (!(this.reviewDeliveryDetails instanceof HTMLElement)) {
          return;
        }
        const reviewDeliveryDetails = this.reviewDeliveryDetails;
        const validItems = items.filter((item) => item.value && item.value !== '-');
        reviewDeliveryDetails.innerHTML = '';

        const itemsToRender = validItems.length
          ? validItems
          : [{ label: 'Details', value: '-' }];

        itemsToRender.forEach((item) => {
          const wrap = document.createElement('div');
          wrap.className = 'customer-verification-form__review-item';

          const label = document.createElement('span');
          label.className = 'customer-verification-form__review-label';
          label.textContent = item.label;

          const value = document.createElement('span');
          value.className = 'customer-verification-form__review-value';
          value.textContent = item.value;

          wrap.appendChild(label);
          wrap.appendChild(value);
          reviewDeliveryDetails.appendChild(wrap);
        });
      }

      updateReviewData() {
        const firstName =
          this.firstNameInput instanceof HTMLInputElement ? this.firstNameInput.value.trim() : '';
        const lastName = this.lastNameInput instanceof HTMLInputElement ? this.lastNameInput.value.trim() : '';
        const fullName = `${firstName} ${lastName}`.trim();
        const phone = this.phoneInput instanceof HTMLInputElement ? this.phoneInput.value : '';
        const dateOfBirth = this.dateOfBirthInput instanceof HTMLInputElement ? this.dateOfBirthInput.value : '';
        const email = this.primaryEmailInput instanceof HTMLInputElement ? this.primaryEmailInput.value : '';

        let arrivalDate = '';
        if (this.arrivalDate instanceof HTMLInputElement && this.arrivalDate.value) {
          arrivalDate = this.formatReadableDate(this.arrivalDate.value);
        } else {
          const arrivalMonth =
            this.arrivalMonthInput instanceof HTMLSelectElement ? this.arrivalMonthInput.value : '';
          const arrivalYear =
            this.arrivalYearInput instanceof HTMLSelectElement ? this.arrivalYearInput.value : '';
          arrivalDate = [arrivalMonth, arrivalYear].filter(Boolean).join(' ');
        }

        /** @type {NodeListOf<HTMLInputElement>} */
        const deliveryOptionInputs = this.deliveryOptionInputs || this.querySelectorAll('[data-delivery-option]');
        let deliveryType = '';
        deliveryOptionInputs.forEach((input) => {
          if (input.checked) {
            deliveryType = input.value;
          }
        });

        if (this.reviewFullName instanceof HTMLElement) {
          this.reviewFullName.textContent = this.getSafeValue(fullName);
        }
        if (this.reviewPhone instanceof HTMLElement) {
          this.reviewPhone.textContent = this.getSafeValue(phone);
        }
        if (this.reviewDateOfBirth instanceof HTMLElement) {
          this.reviewDateOfBirth.textContent = this.getSafeValue(this.formatReadableDate(dateOfBirth));
        }
        if (this.reviewEmail instanceof HTMLElement) {
          this.reviewEmail.textContent = this.getSafeValue(email);
        }
        if (this.reviewArrivalDate instanceof HTMLElement) {
          this.reviewArrivalDate.textContent = this.getSafeValue(arrivalDate);
        }
        if (this.reviewDeliveryType instanceof HTMLElement) {
          this.reviewDeliveryType.textContent = this.getSafeValue(deliveryType);
        }

        if (deliveryType === 'Get an eSIM') {
          const esimEmail = this.deliveryEsimEmail instanceof HTMLInputElement ? this.deliveryEsimEmail.value : '';
          this.renderReviewDeliveryDetails([{ label: 'Email', value: this.getSafeValue(esimEmail || email) }]);
          return;
        }

        if (deliveryType === 'Pickup at the Airport') {
          const airport =
            this.deliveryAirportSelect instanceof HTMLSelectElement ? this.deliveryAirportSelect.value : '';
          this.renderReviewDeliveryDetails([{ label: 'Pickup airport', value: this.getSafeValue(airport) }]);
          return;
        }

        if (deliveryType === 'Deliver to my Home Country') {
          const address =
            this.homeCountryAddressInput instanceof HTMLInputElement ? this.homeCountryAddressInput.value : '';
          const unit = this.homeCountryUnitInput instanceof HTMLInputElement ? this.homeCountryUnitInput.value : '';
          const city = this.homeCountryCityInput instanceof HTMLInputElement ? this.homeCountryCityInput.value : '';
          const region =
            this.homeCountryRegionInput instanceof HTMLInputElement ? this.homeCountryRegionInput.value : '';
          const country =
            this.homeCountryCountryInput instanceof HTMLInputElement ? this.homeCountryCountryInput.value : '';
          const zip = this.homeCountryZipInput instanceof HTMLInputElement ? this.homeCountryZipInput.value : '';
          this.renderReviewDeliveryDetails([
            { label: 'Address', value: this.getSafeValue(address) },
            { label: 'Unit #', value: this.getSafeValue(unit) },
            { label: 'City', value: this.getSafeValue(city) },
            { label: 'Region', value: this.getSafeValue(region) },
            { label: 'Country', value: this.getSafeValue(country) },
            { label: 'Zip code', value: this.getSafeValue(zip) }
          ]);
          return;
        }

        if (deliveryType === 'Deliver to Canadian Address') {
          const address = this.canadianAddressInput instanceof HTMLInputElement ? this.canadianAddressInput.value : '';
          const unit = this.canadianUnitInput instanceof HTMLInputElement ? this.canadianUnitInput.value : '';
          const postal = this.canadianPostalInput instanceof HTMLInputElement ? this.canadianPostalInput.value : '';
          const city = this.canadianCityInput instanceof HTMLInputElement ? this.canadianCityInput.value : '';
          const province =
            this.canadianProvinceInput instanceof HTMLInputElement ? this.canadianProvinceInput.value : '';
          this.renderReviewDeliveryDetails([
            { label: 'Address', value: this.getSafeValue(address) },
            { label: 'Unit #', value: this.getSafeValue(unit) },
            { label: 'City', value: this.getSafeValue(city) },
            { label: 'Zip code', value: this.getSafeValue(postal) },
            { label: 'Country', value: 'Canada' },
            { label: 'State', value: this.getSafeValue(province) }
          ]);
          return;
        }

        this.renderReviewDeliveryDetails([]);
      }

      updateArrivalSubstepView() {
        if (
          !(this.arrivalSubstepOne instanceof HTMLElement) ||
          !(this.arrivalSubstepYes instanceof HTMLElement) ||
          !(this.arrivalSubstepNo instanceof HTMLElement) ||
          !(this.arrivalContinueButton instanceof HTMLButtonElement)
        ) {
          return;
        }

        const isStepTwo = this.currentStep === 2;
        const showQuestion = isStepTwo && this.arrivalSubstep === 1;
        const showYes = isStepTwo && this.arrivalSubstep === 2 && this.arrivalChoiceValue === 'Yes';
        const showNo = isStepTwo && this.arrivalSubstep === 2 && this.arrivalChoiceValue === 'No';

        this.arrivalSubstepOne.toggleAttribute('hidden', !showQuestion);
        this.arrivalSubstepYes.toggleAttribute('hidden', !showYes);
        this.arrivalSubstepNo.toggleAttribute('hidden', !showNo);
        this.arrivalContinueButton.toggleAttribute('hidden', !showQuestion);

        if (this.arrivalDate instanceof HTMLInputElement) {
          this.arrivalDate.required = showYes;
        }
        if (this.arrivalMonth instanceof HTMLSelectElement) {
          this.arrivalMonth.required = showNo;
        }
        if (this.arrivalYear instanceof HTMLSelectElement) {
          this.arrivalYear.required = showNo;
        }
      }

      updateDeliverySubstepView() {
        if (
          !(this.deliverySubstepOne instanceof HTMLElement) ||
          !(this.deliverySubstepTwo instanceof HTMLElement) ||
          !(this.deliverySubstepThree instanceof HTMLElement) ||
          !(this.deliveryContinueButton instanceof HTMLButtonElement) ||
          !(this.deliveryOptionsWithAirport instanceof HTMLElement) ||
          !(this.deliveryOptionsWithoutAirport instanceof HTMLElement)
        ) {
          return;
        }

        const isStepThree = this.currentStep === 3;
        const showSubstepOne = isStepThree && this.deliverySubstep === 1;
        const showSubstepTwo = isStepThree && this.deliverySubstep === 2;
        const showSubstepThree = isStepThree && this.deliverySubstep === 3;
        const showWithAirport = showSubstepTwo && this.deliveryOptionSet === 'with-airport';
        const showWithoutAirport = showSubstepTwo && this.deliveryOptionSet === 'without-airport';

        this.deliverySubstepOne.toggleAttribute('hidden', !showSubstepOne);
        this.deliverySubstepTwo.toggleAttribute('hidden', !showSubstepTwo);
        this.deliverySubstepThree.toggleAttribute('hidden', !showSubstepThree);
        this.deliveryContinueButton.toggleAttribute('hidden', !showSubstepOne);
        this.deliveryOptionsWithAirport.toggleAttribute('hidden', !showWithAirport);
        this.deliveryOptionsWithoutAirport.toggleAttribute('hidden', !showWithoutAirport);

        /** @type {string} */
        let selectedDeliveryOptionValue = this.deliverySelectedOptionValue || '';
        /** @type {NodeListOf<HTMLInputElement>} */
        const deliveryOptionInputs = this.deliveryOptionInputs || this.querySelectorAll('[data-delivery-option]');
        deliveryOptionInputs.forEach((input) => {
          const parentSet = input.closest('[data-delivery-options-set]');
          const belongsToWithAirportSet =
            parentSet instanceof HTMLElement && parentSet.dataset.deliveryOptionsSet === 'with-airport';
          const belongsToWithoutAirportSet =
            parentSet instanceof HTMLElement && parentSet.dataset.deliveryOptionsSet === 'without-airport';

          if (
            showSubstepTwo &&
            ((belongsToWithAirportSet && !showWithAirport) || (belongsToWithoutAirportSet && !showWithoutAirport))
          ) {
            input.checked = false;
          }

          if (input.checked) {
            selectedDeliveryOptionValue = input.value;
          }
        });

        this.deliverySelectedOptionValue = selectedDeliveryOptionValue;
        const showEsimContent = showSubstepThree && this.deliverySelectedOptionValue === 'Get an eSIM';
        const showAirportContent = showSubstepThree && this.deliverySelectedOptionValue === 'Pickup at the Airport';
        const showHomeCountryContent =
          showSubstepThree && this.deliverySelectedOptionValue === 'Deliver to my Home Country';
        const showCanadianAddressContent =
          showSubstepThree && this.deliverySelectedOptionValue === 'Deliver to Canadian Address';
        if (this.deliveryEsimContent instanceof HTMLElement) {
          this.deliveryEsimContent.toggleAttribute('hidden', !showEsimContent);
        }
        if (this.deliveryAirportContent instanceof HTMLElement) {
          this.deliveryAirportContent.toggleAttribute('hidden', !showAirportContent);
        }
        if (this.deliveryHomeCountryContent instanceof HTMLElement) {
          this.deliveryHomeCountryContent.toggleAttribute('hidden', !showHomeCountryContent);
        }
        if (this.deliveryCanadianAddressContent instanceof HTMLElement) {
          this.deliveryCanadianAddressContent.toggleAttribute('hidden', !showCanadianAddressContent);
        }
        if (this.deliveryEsimHelp instanceof HTMLElement && !showEsimContent) {
          this.deliveryEsimHelp.setAttribute('hidden', '');
        }
        if (this.deliveryEsimEmail instanceof HTMLInputElement) {
          this.deliveryEsimEmail.required = showEsimContent;
          if (
            showEsimContent &&
            this.primaryEmailInput instanceof HTMLInputElement &&
            this.deliveryEsimEmail.value.trim() === ''
          ) {
            this.deliveryEsimEmail.value = this.primaryEmailInput.value;
          }
        }
        if (this.deliveryAirportSelect instanceof HTMLSelectElement) {
          this.deliveryAirportSelect.required = showAirportContent;
        }
        /** @type {NodeListOf<HTMLInputElement>} */
        const deliveryHomeCountryFields =
          this.deliveryHomeCountryFields || this.querySelectorAll('[data-delivery-home-country-field]');
        deliveryHomeCountryFields.forEach((field) => {
          field.required = showHomeCountryContent;
        });
        /** @type {NodeListOf<HTMLInputElement>} */
        const deliveryCanadianFields =
          this.deliveryCanadianFields || this.querySelectorAll('[data-delivery-canadian-field]');
        deliveryCanadianFields.forEach((field) => {
          field.required = showCanadianAddressContent;
        });
        if (
          showHomeCountryContent &&
          this.deliveryHomeCountry instanceof HTMLInputElement &&
          this.deliveryHomeCountry.value.trim() === ''
        ) {
          const deliveryCountryInput = this.querySelector('[name="contact[delivery_country]"]');
          if (deliveryCountryInput instanceof HTMLSelectElement) {
            this.deliveryHomeCountry.value = deliveryCountryInput.value;
          }
        }
        if (
          showCanadianAddressContent &&
          this.deliveryCanadianProvince instanceof HTMLInputElement &&
          this.deliveryProvinceSelect instanceof HTMLSelectElement &&
          this.deliveryCanadianProvince.value.trim() === ''
        ) {
          const selectedOption =
            this.deliveryProvinceSelect.selectedOptions.length > 0
              ? this.deliveryProvinceSelect.selectedOptions[0]
              : null;
          this.deliveryCanadianProvince.value = selectedOption ? selectedOption.text : '';
        }

        deliveryOptionInputs.forEach((input) => {
          const parentSet = input.closest('[data-delivery-options-set]');
          const shouldRequire =
            showSubstepTwo &&
            parentSet instanceof HTMLElement &&
            ((showWithAirport && parentSet.dataset.deliveryOptionsSet === 'with-airport') ||
              (showWithoutAirport && parentSet.dataset.deliveryOptionsSet === 'without-airport'));
          input.required = shouldRequire;
        });
      }
    }
  );
}
